import Highcharts from '~/scripts/integrations/highcharts';

class CompanyEventBudgetCalculator {
  constructor() {
    this.budgetChart = null;
    this.init();
  }

  init() {
    this.bindEvents();
    this.setDefaultValues();
  }

  bindEvents() {
    $('#calculate-picnic-budget').on('click', () => this.calculateBudget());
    $('#reset-picnic-calculator').on('click', () => this.resetCalculator());
    
    // Auto-calculate on input changes
    $('input, select').on('input change', () => {
      if (this.hasValidInputs()) {
        this.calculateBudget();
      }
    });
  }

  setDefaultValues() {
    // Set current date
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
    $('#event-date').val(nextMonth.toISOString().split('T')[0]);
    
    // Set reasonable defaults
    $('#attendee-count').val(100);
    $('#venue-rental').val(500);
    $('#venue-deposit').val(100);
    $('#parking-fees').val(5);
    $('#estimated-vehicles').val(50);
    $('#food-catering').val(25);
    $('#beverages').val(8);
    $('#alcohol').val(15);
    $('#desserts-snacks').val(5);
    $('#serving-equipment').val(200);
    $('#ice-coolers').val(150);
    $('#live-entertainment').val(800);
    $('#games-activities').val(300);
    $('#prizes-awards').val(500);
    $('#photography').val(400);
    $('#shuttle-service').val(10);
    $('#shuttle-attendees').val(30);
    $('#mileage-reimbursement').val(0.65);
    $('#total-miles').val(20);
    $('#parking-permit').val(10);
    $('#permits-needed').val(5);
    $('#decorations').val(300);
    $('#tableware').val(3);
    $('#tables-chairs').val(400);
    $('#tents-canopies').val(600);
    $('#first-aid').val(100);
    $('#misc-supplies').val(200);
    $('#event-insurance').val(300);
    $('#permits-licenses').val(150);
  }

  hasValidInputs() {
    const attendeeCount = parseInt($('#attendee-count').val()) || 0;
    return attendeeCount > 0;
  }

  calculateBudget() {
    if (!this.hasValidInputs()) {
      alert('Please enter the number of expected attendees to calculate the budget.');
      return;
    }

    const attendeeCount = parseInt($('#attendee-count').val());
    const eventDuration = parseInt($('#event-duration').val());

    // Calculate venue & location costs
    const venueRental = parseFloat($('#venue-rental').val()) || 0;
    const venueDeposit = parseFloat($('#venue-deposit').val()) || 0;
    const parkingFees = parseFloat($('#parking-fees').val()) || 0;
    const estimatedVehicles = parseInt($('#estimated-vehicles').val()) || 0;
    const parkingPermit = parseFloat($('#parking-permit').val()) || 0;
    const permitsNeeded = parseInt($('#permits-needed').val()) || 0;

    const venueLocationTotal = venueRental + venueDeposit + (parkingFees * estimatedVehicles) + (parkingPermit * permitsNeeded);

    // Calculate food & beverages
    const foodCatering = parseFloat($('#food-catering').val()) || 0;
    const beverages = parseFloat($('#beverages').val()) || 0;
    const alcohol = parseFloat($('#alcohol').val()) || 0;
    const dessertsSnacks = parseFloat($('#desserts-snacks').val()) || 0;
    const servingEquipment = parseFloat($('#serving-equipment').val()) || 0;
    const iceCoolers = parseFloat($('#ice-coolers').val()) || 0;

    const foodBeveragesTotal = (foodCatering + beverages + alcohol + dessertsSnacks) * attendeeCount + servingEquipment + iceCoolers;

    // Calculate activities & entertainment
    const liveEntertainment = parseFloat($('#live-entertainment').val()) || 0;
    const gamesActivities = parseFloat($('#games-activities').val()) || 0;
    const prizesAwards = parseFloat($('#prizes-awards').val()) || 0;
    const photography = parseFloat($('#photography').val()) || 0;

    const activitiesEntertainmentTotal = liveEntertainment + gamesActivities + prizesAwards + photography;

    // Calculate travel & transportation
    const shuttleService = parseFloat($('#shuttle-service').val()) || 0;
    const shuttleAttendees = parseInt($('#shuttle-attendees').val()) || 0;
    const mileageReimbursement = parseFloat($('#mileage-reimbursement').val()) || 0;
    const totalMiles = parseFloat($('#total-miles').val()) || 0;

    const travelTransportationTotal = (shuttleService * shuttleAttendees) + (mileageReimbursement * totalMiles * estimatedVehicles);

    // Calculate supplies & decorations
    const decorations = parseFloat($('#decorations').val()) || 0;
    const tableware = parseFloat($('#tableware').val()) || 0;
    const tablesChairs = parseFloat($('#tables-chairs').val()) || 0;
    const tentsCanopies = parseFloat($('#tents-canopies').val()) || 0;
    const firstAid = parseFloat($('#first-aid').val()) || 0;
    const miscSupplies = parseFloat($('#misc-supplies').val()) || 0;

    const suppliesDecorationsTotal = decorations + (tableware * attendeeCount) + tablesChairs + tentsCanopies + firstAid + miscSupplies;

    // Calculate insurance & permits
    const eventInsurance = parseFloat($('#event-insurance').val()) || 0;
    const permitsLicenses = parseFloat($('#permits-licenses').val()) || 0;

    const insurancePermitsTotal = eventInsurance + permitsLicenses;

    // Calculate totals
    const totalBudget = venueLocationTotal + foodBeveragesTotal + activitiesEntertainmentTotal + 
                       travelTransportationTotal + suppliesDecorationsTotal + insurancePermitsTotal;
    const perPersonCost = totalBudget / attendeeCount;

    // Display results
    this.displayResults({
      venueLocationTotal,
      foodBeveragesTotal,
      activitiesEntertainmentTotal,
      travelTransportationTotal,
      suppliesDecorationsTotal,
      insurancePermitsTotal,
      totalBudget,
      perPersonCost,
      attendeeCount,
      eventDuration
    });

    $('#picnic-results-section').show();
  }

  displayResults(results) {
    const breakdownList = $('#picnic-budget-breakdown-list');
    breakdownList.empty();

    const categories = [
      { name: 'Venue & Location', amount: results.venueLocationTotal, color: 'success' },
      { name: 'Food & Beverages', amount: results.foodBeveragesTotal, color: 'warning' },
      { name: 'Activities & Entertainment', amount: results.activitiesEntertainmentTotal, color: 'info' },
      { name: 'Travel & Transportation', amount: results.travelTransportationTotal, color: 'danger' },
      { name: 'Supplies & Decorations', amount: results.suppliesDecorationsTotal, color: 'secondary' },
      { name: 'Insurance & Permits', amount: results.insurancePermitsTotal, color: 'dark' }
    ];

    categories.forEach(category => {
      const percentage = ((category.amount / results.totalBudget) * 100).toFixed(1);
      const breakdownItem = `
        <div class="card border-start border-4 border-${category.color} mb-3">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="card-title mb-1">${category.name}</h6>
                <small class="text-muted">${percentage}% of total budget</small>
              </div>
              <div class="text-end">
                <div class="fs-5 fw-bold text-${category.color}">$${category.amount.toLocaleString()}</div>
              </div>
            </div>
          </div>
        </div>
      `;
      breakdownList.append(breakdownItem);
    });

    // Update summary values
    $('#total-picnic-budget').text(`$${results.totalBudget.toLocaleString()}`);
    $('#per-person-cost').text(`$${results.perPersonCost.toLocaleString()}`);
    $('#total-attendees').text(results.attendeeCount.toLocaleString());
    $('#event-duration-display').text(`${results.eventDuration} hours`);

    // Update chart
    this.updateBudgetChart(categories, results.totalBudget);
  }

  updateBudgetChart(categories, totalBudget) {
    const chartData = categories.map(category => ({
      name: category.name,
      y: category.amount,
      color: this.getCategoryColor(category.color)
    }));

    if (this.budgetChart) {
      this.budgetChart.destroy();
    }

    this.budgetChart = Highcharts.chart('event-budget-chart', {
      chart: {
        type: 'pie',
        height: 400
      },
      title: {
        text: 'Event Budget Breakdown'
      },
      tooltip: {
        pointFormat: '<b>{point.name}</b><br/>' +
                    'Amount: ${point.y:,.0f}<br/>' +
                    'Percentage: {point.percentage:.1f}%'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b><br/>${point.y:,.0f} ({point.percentage:.1f}%)'
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Budget Categories',
        colorByPoint: true,
        data: chartData
      }]
    });
  }

  getCategoryColor(bootstrapColor) {
    const colorMap = {
      'success': '#198754',
      'warning': '#ffc107',
      'info': '#0dcaf0',
      'danger': '#dc3545',
      'secondary': '#6c757d',
      'dark': '#212529'
    };
    return colorMap[bootstrapColor] || '#6c757d';
  }

  resetCalculator() {
    $('#picnic-budget-form')[0].reset();
    $('#picnic-results-section').hide();
    
    // Destroy chart if it exists
    if (this.budgetChart) {
      this.budgetChart.destroy();
      this.budgetChart = null;
    }
    
    this.setDefaultValues();
  }
}

// Export the class for use in other modules
export default CompanyEventBudgetCalculator;
